import style from "./CardsContainer.module.css";
import CardCountry from "../CardCountry/CardCountry";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { getAllCountries } from "../../Redux/actions/actions";
import { Link } from "react-router-dom";
import Paginado from "../Paginado/Paginado";
import NotFound2 from "../../images/NotFound2.gif";
import Loading from "../../images/loadingHome.gif";

const CardsContainer = () => {
  const dispatch = useDispatch();

  const { countriesCopy, countries } = useSelector((state) => state);

  const [paginaActual, setPaginaActual] = useState(1);
  const [paisPorPagina] = useState(10);

  const indiceDelUltimoPais = paginaActual * paisPorPagina;
  const indiceDelPrimerPais = indiceDelUltimoPais - paisPorPagina;
  const paisesActuales = countriesCopy.slice(
    indiceDelPrimerPais,
    indiceDelUltimoPais
  );

  const paginado = (numeroDePagina) => {
    setPaginaActual(numeroDePagina);
  };

  useEffect(() => {
    if (countries.length === 0) {
      dispatch(getAllCountries());
    }
  }, [dispatch, countries]);
  useEffect(() => {
    setPaginaActual(1);
  }, [countriesCopy]);

  return (
    <div>
      <section>
        <Paginado
          paisPorPagina={paisPorPagina}
          todoLongitud={countriesCopy.length}
          paginado={paginado}
        />
      </section>
      {paisesActuales.length ? (
        <section className={style.cardsContainer}>
          {paisesActuales?.map((pais) => {
            if (pais.id === "No encontrado") {
              return (
                <Link key={pais.id} className={style.notFound} to={`/home`}>
                  <img src={NotFound2} alt="NotFound" />
                  <div>
                    <h3>Pais no encontrado!</h3>
                    <p>No hay coincidencias con ese nombre</p>
                  </div>
                </Link>
              );
            }
            return (
              <Link
                key={pais.id}
                className={style.link}
                to={`/detail/${pais.id}`}
              >
                <CardCountry
                  id={pais.id}
                  name={pais.name}
                  img={pais.img[1]}
                  continent={pais.continent}
                />
              </Link>
            );
          })}
        </section>
      ) : (
        <img src={Loading} alt="" />
      )}
    </div>
  );
};

export default CardsContainer;
